export default "__VITE_ASSET__u2uwZxQ8__"